import { useEffect, useState, type Dispatch, type SetStateAction } from 'react'
import { useSearchParams } from 'react-router-dom'

// Drop-in replacement for `useState(false)` that backs a project's Share dialog. In addition to the
// usual open/close state, it auto-opens the dialog when the project is loaded with `?share=1` — the
// deep-link emitted by the "Share" CTA in the project-completion email — and then strips the param
// (replace, not push) so a refresh or Back navigation doesn't reopen it.
export function useShareDialog(): [boolean, Dispatch<SetStateAction<boolean>>] {
  const [searchParams, setSearchParams] = useSearchParams()
  const [showShare, setShowShare] = useState(false)

  useEffect(() => {
    if (searchParams.get('share') === '1') {
      setShowShare(true)
      const next = new URLSearchParams(searchParams)
      next.delete('share')
      setSearchParams(next, { replace: true })
    }
  }, [searchParams, setSearchParams])

  return [showShare, setShowShare]
}
